import { queryOptions } from "@tanstack/react-query";
import {
  getMcpAuthorization,
  listMcpConnections,
  type McpAuthorizationRequest,
} from "api-client";

export function mcpConnectionsQueryOptions() {
  return queryOptions({
    queryKey: ["mcp", "connections"],
    queryFn: async () => {
      const response = await listMcpConnections();
      return response.data.data;
    },
  });
}

export function mcpAuthorizationQueryOptions(request: McpAuthorizationRequest) {
  return queryOptions({
    queryKey: ["mcp", "authorization", request],
    queryFn: async () => {
      const response = await getMcpAuthorization({
        query: request,
        throwOnError: false,
      });

      if (response.error) {
        throw new Error(response.error.error.message);
      }

      return response.data.data;
    },
    retry: false,
  });
}
